import React from 'react';
import { useTranslation } from 'react-i18next';
import ArrowDownIcon from '../../assets/icons/ArrowDownIcon';
import ArrowUpIcon from '../../assets/icons/ArrowUpIcon';
import { COLORS } from '../../styles/variables';
import {
  ExposedButton,
  Header,
  HeaderTitle,
  OfferShortDetails,
  Vehicle,
  VehicleOfInterest,
} from './VehicleInfo.styles';
import type { OffersTypes } from '../../types';

interface FilterExposedHeaderTypes {
  isOpened: boolean;
  modelName?: string;
  isOfferPage?: boolean;
  offers?: OffersTypes | null;
  vehicleLabel: string;
  setIsOpened: (arg: boolean) => void;
}

const ExposedHeader: React.FC<FilterExposedHeaderTypes> = ({
  isOpened,
  modelName,
  isOfferPage,
  offers,
  vehicleLabel,
  setIsOpened,
}) => {
  const { t } = useTranslation();
  const isBonusOffer = offers?.offerType === 'credit';

  return (
    <ExposedButton
      tabIndex={-1}
      onClick={() => {
        setIsOpened(!isOpened);
      }}
    >
      <Header>
        <HeaderTitle>{vehicleLabel}</HeaderTitle>
        <VehicleOfInterest>
          {isOfferPage && (
            <OfferShortDetails>
              {t(`digitalLeads.vehicle.offers.${offers?.offerType}`)} -
            </OfferShortDetails>
          )}
          {isBonusOffer ? (
            <OfferShortDetails>
              {offers?.offerDetails?.creditBonus} {t('digitalLeads.vehicle.offers.credit')}
            </OfferShortDetails>
          ) : (
            <Vehicle>{modelName}</Vehicle>
          )}
        </VehicleOfInterest>
      </Header>
      {isOpened ? <ArrowUpIcon color={COLORS.black} /> : <ArrowDownIcon color={COLORS.black} />}
    </ExposedButton>
  );
};

export default ExposedHeader;
